import {InjectionToken} from "@angular/core";
import {Observable, of} from "rxjs";

export const INT_EMPTY_LIST_LABEL = new InjectionToken<Observable<string>>('INT_EMPTY_LIST_LABEL', {
  factory() {
    return of('Empty list');
  }
})
